import React, { useState, useEffect } from "react";
import { SiGmail } from "react-icons/si";
import { FcPhoneAndroid } from "react-icons/fc";
import { FaLocationArrow } from "react-icons/fa";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../Firebase";

function Contact() {
  const [contact, setContact] = useState([]);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, "contact", "XqMhhWmckttAm9m4okec"),
      (doc) => {
        setContact(doc.data());
      }
    );

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <>
      <div id="container">
        <div className="max-w-[1440px] w-full p-4">
          <div className="flex flex-col justify-center mt-24 lg:mt-0 lg:h-screen">
            <div className="flex justify-center">
              <div className="max-w-4xl bg-slate-800 rounded-xl border border-green-400 shadow-xl shadow-green-900 w-full text-center">
                <h4 className="p-10 font-bold text-6xl">{contact.title}</h4>
                <div className="lg:flex justify-center space-x-8 p-4 py-10 ">
                  <a href={"tel:" + contact.phone}>
                    <div className=" p-8 rounded-xl border border-green-400 bg-slate-700 shadow-md hover:shadow-none shadow-green-400">
                      <div className="flex justify-center mb-4">
                        <FcPhoneAndroid size={"30px"} />
                      </div>
                      <p>{contact.phone}</p>
                    </div>
                  </a>
                  <a href={"mailto:" + contact.mail}>
                    <div className="p-8 rounded-xl border border-green-400 bg-slate-700 shadow-md hover:shadow-none shadow-green-400">
                      <div className="flex justify-center mb-4">
                        <SiGmail size={"30px"} />
                      </div>
                      <p>{contact.mail}</p>
                    </div>
                  </a>
                  <a href={contact.addressURL} target="_blank" rel="noreferrer">
                    <div className="p-5 rounded-xl border border-green-400 bg-slate-700 shadow-md hover:shadow-none shadow-green-400">
                      <div className="flex justify-center mb-4">
                        <FaLocationArrow size={"30px"} />
                      </div>
                      <p>{contact.address}</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
